import { motion } from 'motion/react';
import { BaseComponentProps, HeaderContentProps } from '../../../types';
import { LastUpdatedTag } from './last-updated-tag';
import { AnimatedCard } from '../../../../common/animated-card';

type HealthDataHeaderCardProps = BaseComponentProps &
  HeaderContentProps & {
    variant?: 'default' | 'editor';
  };

export function HealthDataHeaderCard({
  heroContent,
  titleContent,
  children,
  variant = 'default',
}: HealthDataHeaderCardProps) {

  return (
    <div className="relative z-10 mx-auto max-w-7xl px-12 pt-3 pb-6 sm:px-6 md:px-16 md:pt-10">
      <AnimatedCard>
        {/* Background grid pattern */}
        <div
          className="absolute inset-0 opacity-54 pointer-events-none bg-[url('/images/bg-points.svg')] bg-center bg-[length:100%] bg-no-repeat md:hidden"
          style={{
            backgroundPositionY: '10%',
          }}
        />

        <div
          className={`relative z-10 flex min-h-[250px] ${variant === 'editor' ? 'flex-col' : 'flex-col lg:flex-row lg:gap-12'}`}
        >
          {/* Left side content */}
          <div
            className={`flex flex-shrink-0 flex-col items-center gap-3 ${
              variant === 'editor' ? 'order-1' : 'order-2 lg:order-1'
            }`}
          >
            <div className="md:hidden">
              <LastUpdatedTag/>
            </div>
            {heroContent && (
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {heroContent}
              </motion.div>
            )}
          </div>

          {/* Right side content - fills remaining space */}
          <div className="order-1 flex flex-1 flex-col justify-center lg:order-2">
            {titleContent}
            {children}
          </div>
        </div>
      </AnimatedCard>
    </div>
  );
}
